/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

/**
 * @description SmartOrderRefill Form Validation
 * @param {Element} element container with fields that need validation
 * @returns {boolean} the validation of the form
 */
function validateForm(element) {
  let formValid = true;
  element.find('.field-wrapper').each(function () {
    const fieldWrapper = $(this);
    const field = fieldWrapper.find('input, select');
    if (field.length > 0) {
      field.removeClass('error');
      fieldWrapper.find(`#${field.attr('id')}-error`).addClass('hide');
      const validState = field[0].validity;

      if (!validState.valid) {
        formValid = false;
        field.addClass('error');
        fieldWrapper.find(`#${field.attr('id')}-error`).removeClass('hide');
      }
    }
  });
  return formValid;
}

/**
 * @description Sanitize string
 * @param {string} input string to be sanitized
 * @returns {string} sanitized string
 */
function sanitizeString(input) {
  let sanitizedString = input;
  if (input && typeof input === 'string') {
    sanitizedString = input.replace(/['";\\()]/g, '');
  }
  return sanitizedString;
}

module.exports = {
  validateForm: validateForm,
  sanitizeString: sanitizeString
};
